// extracted by mini-css-extract-plugin
export default {"price":"qba-z","onSale":"rba-z","msrpLabelPrice":"sba-z","msrpLabel":"tba-z","originalPrice":"uba-z"};